import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export function BreadCrumbs({ items }) {
  return (
    <nav className="flex text-sm font-normal font-sans text-gray-400 dark:text-gray-400 ml-6 !p-0" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1">
        {items.map((item, index) => (
          <li key={index} className="inline-flex items-center">
            {item.href ? (
              <Link to={item.href} className="text-gray-400 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 capitalize">
                {item.label}
              </Link>
            ) : (
              <span className={`capitalize ${index === items.length - 1 ? 'text-black dark:text-gray-100 font-medium' : 'text-gray-500 dark:text-gray-400'}`}>
                {item.label}
              </span>
            )}
            {index < items.length - 1 && (
              <span className="text-gray-400 dark:text-gray-500 pl-2 pr-1"><ChevronRight size={14} className="text-gray-400 dark:text-gray-500" /></span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
